/*
 * jQuery fixedUI plugin
 *
 * Copyright(C) 2007 LEARNING RESOURCE LAB.
 * http://developmentor.lrlab.to/postal/
 *
 * Dual licensed under the MIT (MIT-LICENSE.txt)
 * and GPL (GPL-LICENSE.txt) licenses.
 */
(function($) {

// $.fixedUI
$.fixedUI = function(expr) {

  var container = $('#fixedUI');
  if (container.length == 0) {
    container = $('<div />')
      .attr('id', 'fixedUI')
      .css({
        display: 'none',
      });

    var body = $('body', document)
      .append(container);
  }

  var element = $(expr, container);
  if (element.length == 0)
    element = $(expr)
      .appendTo(container);
  element
    .addClass('fixedUI')
    .show();

  container.slideDown();
};

// $.unfixedUI
$.unfixedUI = function() {

  $('#fixedUI').slideUp(function() {
    $('.fixedUI', this).hide();
  });
};

// $.fixedUI.impl
$.fixedUI.impl = {
};

})(jQuery); // function($)